import cx from "classnames";

import AppImage from "components/AppImage";

import styles from "./LandingPageMovieSelectionCover.module.scss";

interface LandingPageMovieSelectionCoverProps {
  src: string;
  className: string;
}
const LandingPageMovieSelectionCover = ({
  src,
  className,
}: LandingPageMovieSelectionCoverProps) => {
  return (
    <div className={cx(styles.cover, className)}>
      <AppImage alt="" src={src} className={styles.img} />
    </div>
  );
};

export default LandingPageMovieSelectionCover;
